var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createHook, createStore } from "react-sweet-state";
import { LoadingStateDefaults } from "framework/state/loadingstate";
import { loadLast } from "framework/state/loader";
import { NoEntityError } from "framework/validation/validatableentity";
import { updateByCollectionResponse } from "framework/state/collection";
import { apiGetPlanningEvents } from "../../endpoint";
import { EventType } from "../../entity";
import { getIsoString, getIsoStringDate, isValidInt } from "framework/helpers";
var FilterStateDefaults = {
    entity: {
        referenceNumber: "",
        state: null,
        role: null,
        dateOption: "future",
        dateFrom: null,
        dateTo: null,
    },
    errors: __assign({}, NoEntityError),
    addOneMonthIndicator: 0,
};
var setFilterValue = function (field, value) { return function (store) {
    var reloadEvents = true;
    store.setState(function (draft) {
        if (field === 'state') {
            if (value === 'null') {
                draft.filter.entity.state = null;
            }
            else {
                draft.filter.entity.state = value;
            }
        }
        else if (field === 'role') {
            reloadEvents = false;
            if (value === 'null') {
                draft.filter.entity.role = null;
            }
            else {
                draft.filter.entity.role = value;
            }
        }
        else if (field === 'referenceNumber') {
            if (isValidInt(value)) {
                draft.filter.entity.referenceNumber = value;
            }
        }
        else if (field === 'dateOption') {
            draft.filter.entity.dateOption = value;
        }
    });
    if (reloadEvents) {
        store.dispatch(loadEvents());
    }
    else {
        store.dispatch(filterEventsByRole());
    }
}; };
var setFilterDateValue = function (field, value) { return function (store) {
    store.setState(function (draft) {
        if (field === 'dateFrom') {
            draft.filter.entity.dateFrom = value;
        }
        if (field === 'dateTo') {
            draft.filter.entity.dateTo = value;
        }
    });
    var state = store.getState();
    if (state.filter.entity.dateFrom !== null && state.filter.entity.dateTo !== null) {
        store.dispatch(loadEvents());
    }
}; };
var EventListStateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError), events: {} });
var formatEventList = function (events, succeeded, roleFilter) {
    var result = {};
    if (succeeded) {
        events.forEach(function (e) { return e.eventCompetitions.filter(function (x) {
            var _a;
            return roleFilter === null
                || ((_a = e.eventCompetitions[0].userPermissionRoles) === null || _a === void 0 ? void 0 : _a.map(function (r) { return r.toString(); }).includes(roleFilter));
        }).forEach(function (c) {
            var key = getIsoStringDate(c.date).substring(0, 7);
            var items = result[key];
            if (items == null) {
                items = [];
                result[key] = items;
            }
            var itemType = EventType.Competition;
            var itemId = c.id;
            items.push(__assign({ key_: "".concat(itemType, "-").concat(itemId), type_: itemType, eventId: e.id }, c));
        }); });
        Object.keys(result).forEach(function (k) {
            result[k] = result[k].sort(function (a, b) { return a.date.getTime() - b.date.getTime(); });
        });
    }
    return result;
};
var loadEvents = function () { return function (store) {
    var state = store.getState();
    var filter = null;
    var fields = [];
    if (state.filter.entity.referenceNumber !== '') {
        fields.push("referenceNumber LIKE '".concat(state.filter.entity.referenceNumber, "'"));
    }
    if (state.filter.entity.state !== null) {
        fields.push("state=".concat(state.filter.entity.state));
    }
    if (state.filter.entity.dateOption === 'future') {
        fields.push("date>=".concat(getIsoString(new Date()).substring(0, 10)));
    }
    if (state.filter.entity.dateOption === 'past') {
        var dateYesterday = new Date();
        dateYesterday.setDate(dateYesterday.getDate() - 1);
        fields.push("date<=".concat(getIsoString(dateYesterday).substring(0, 10)));
    }
    if (state.filter.entity.dateOption === 'range') {
        if (state.filter.entity.dateFrom !== null && state.filter.entity.dateTo !== null) {
            fields.push("date>=".concat(getIsoString(state.filter.entity.dateFrom).substring(0, 10)));
            fields.push("date<=".concat(getIsoString(state.filter.entity.dateTo).substring(0, 10)));
        }
        else {
            store.setState(function (draft) {
                draft.eventsList.collection = [];
                draft.eventsList.events = {};
            });
            return;
        }
    }
    if (fields.length > 0) {
        filter = fields.join(" AND ");
    }
    var loader = function () { return apiGetPlanningEvents(filter); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByCollectionResponse(draft.eventsList, response);
            draft.eventsList.events = formatEventList(draft.eventsList.collection, response.succeeded, draft.filter.entity.role);
        });
    };
    loadLast(store, loader, stateProducer, function (s) { return s.eventsList; });
}; };
var filterEventsByRole = function () { return function (store) {
    store.setState(function (draft) {
        draft.eventsList.events = formatEventList(draft.eventsList.collection, true, draft.filter.entity.role);
    });
}; };
var StateDefaults = __assign(__assign({}, LoadingStateDefaults), { eventsList: EventListStateDefaults, filter: FilterStateDefaults });
var store = createStore({
    initialState: StateDefaults,
    actions: {
        loadEvents: loadEvents,
        setFilterValue: setFilterValue,
        setFilterDateValue: setFilterDateValue,
    },
    name: "EventPlanningList"
});
var useState = createHook(store);
export { StateDefaults as EventsPlanningListDefaults, useState as useEventsPlanningList, };
